export enum NdbxIcons {
  ArrowDownSlim = "arrow-down-slim",
  ArrowDown = "arrow-down",
  ArrowDownload = "arrow-download",
  ArrowFirst = "arrow-first",
  ArrowLast = "arrow-last",
  ArrowLeftSlim = "arrow-left-slim",
  ArrowLeft = "arrow-left",
  ArrowRightSlim = "arrow-right-slim",
  ArrowRight = "arrow-right",
  ArrowUpSlim = "arrow-up-slim",
  ArrowUp = "arrow-up",
  ArrowUpload = "arrow-upload",
  Back = "back",
  Bars = "bars",
  BellO = "bell-o",
  BellOffO = "bell-off-o",
  BellOff = "bell-off",
  Bell = "bell",
  BoardShareGraph = "board-share-graph",
  BoltO = "bolt-o",
  Bolt = "bolt",
  BookmarkO = "bookmark-o",
  Bookmark = "bookmark",
  CalendarDateCheckO = "calendar-date-check-o",
  CalendarDateCheck = "calendar-date-check",
  CalendarDefault = "calendar-default",
  CalendarReminderO = "calendar-reminder-o",
  CalendarReminder = "calendar-reminder",
  Calendar = "calendar",
  CardO = "card-o",
  CertificatePapers = "certificate-papers",
  ChatO = "chat-o",
  Chat = "chat",
  CheckCircle = "check-circle",
  Check = "check",
  ChevronDownSmall = "chevron-down-small",
  ChevronDown = "chevron-down",
  ChevronLeftCircleO = "chevron-left-circle-o",
  ChevronLeftCircle = "chevron-left-circle",
  ChevronLeftSmall = "chevron-left-small",
  ChevronLeft = "chevron-left",
  ChevronRightCircleO = "chevron-right-circle-o",
  ChevronRightCircle = "chevron-right-circle",
  ChevronRightSmall = "chevron-right-small",
  ChevronRight = "chevron-right",
  ChevronUpSmall = "chevron-up-small",
  ChevronUp = "chevron-up",
  ClockO = "clock-o",
  Clock = "clock",
  CloseCircleO = "close-circle-o",
  CloseCircle = "close-circle",
  Close = "close",
  CobrowsingO = "cobrowsing-o",
  CreditCardO = "credit-card-o",
  CreditCard = "credit-card",
  DocText = "doc-text",
  Doc = "doc",
  Dot = "dot",
  Download = "download",
  Duplicate = "duplicate",
  EMailReadO = "e-mail-read-o",
  EMailRead = "e-mail-read",
  Edit = "edit",
  EllipsisH = "ellipsis-h",
  EllipsisV = "ellipsis-v",
  EpsText = "eps-text",
  Eps = "eps",
  ExclamationCircleO = "exclamation-circle-o",
  ExclamationCircle = "exclamation-circle",
  ExclamationTriangleO = "exclamation-triangle-o",
  ExclamationTriangle = "exclamation-triangle",
  ExportAndShare = "export-and-share",
  FacebookCircle = "facebook-circle",
  Facebook = "facebook",
  FileDocument = "file-document",
  FileFlag = "file-flag",
  FileText = "file-text",
  File = "file",
  Filter = "filter",
  FountainPen = "fountain-pen",
  GoogleCircle = "google-circle",
  GooglePlus = "google-plus",
  Grapes = "grapes",
  HandCogWheel = "hand-cog-wheel",
  HandTray = "hand-tray",
  HelmetConstruction = "helmet-construction",
  HelpQuestionF = "help-question-f",
  ImgText = "img-text",
  Img = "img",
  InProgress = "in-progress",
  InfoCircleO = "info-circle-o",
  InfoCircle = "info-circle",
  InstagramCircle = "instagram-circle",
  Instagram = "instagram",
  JpgText = "jpg-text",
  Jpg = "jpg",
  LaptopCogWheel = "laptop-cog-wheel",
  Launch = "launch",
  LinkedinCircle = "linkedin-circle",
  Linkedin = "linkedin",
  List = "list",
  LocationO = "location-o",
  Location = "location",
  LockO = "lock-o",
  LockUnlockO = "lock-unlock-o",
  LockUnlock = "lock-unlock",
  Lock = "lock",
  MailCircle = "mail-circle",
  MailO = "mail-o",
  Mail = "mail",
  Manager = "manager",
  MessengerCircle = "messenger-circle",
  Messenger = "messenger",
  MicrophoneDefault = "microphone-default",
  MicrophoneMuteO = "microphone-mute-o",
  MicrophoneMute = "microphone-mute",
  Microphone = "microphone",
  MinusCircleO = "minus-circle-o",
  MinusCircle = "minus-circle",
  Minus = "minus",
  Mp3Text = "mp3-text",
  Mp3 = "mp3",
  Paperclip = "paperclip",
  PasswordHideO = "password-hide-o",
  PasswordHide = "password-hide",
  PasswordShowO = "password-show-o",
  PasswordShow = "password-show",
  Pause = "pause",
  PdfText = "pdf-text",
  Pdf = "pdf",
  Pen = "pen",
  PhoneChatO = "phone-chat-o",
  PhoneChat = "phone-chat",
  PhoneO = "phone-o",
  Phone = "phone",
  Play = "play",
  PlusCircleO = "plus-circle-o",
  PlusCircle = "plus-circle",
  Plus = "plus",
  PodText = "pod-text",
  Pod = "pod",
  Popout = "popout",
  PptText = "ppt-text",
  Ppt = "ppt",
  PrintO = "print-o",
  Print = "print",
  ProductAZ = "product-a-z",
  ProductAnimalCat = "product-animal-cat",
  ProductAnimalDog = "product-animal-dog",
  ProductAnimalHorse = "product-animal-horse",
  ProductAnimalHuntingDeer = "product-animal-hunting-deer",
  ProductAnimalPaw = "product-animal-paw",
  ProductApartmentBuilding = "product-apartment-building",
  ProductArrowDirectionPath = "product-arrow-direction-path",
  ProductAtSign = "product-at-sign",
  ProductBalanceScale = "product-balance-scale",
  ProductBankMonumentInfo = "product-bank-monument-info",
  ProductBattery = "product-battery",
  ProductBed = "product-bed",
  ProductBereavedDependentPension = "product-bereaved-dependent-pension",
  ProductBike = "product-bike",
  ProductBlog = "product-blog",
  ProductBoardPaperNote = "product-board-paper-note",
  ProductBook = "product-book",
  ProductBrain = "product-brain",
  ProductBrokenGlass = "product-broken-glass",
  ProductBrokenWindow = "product-broken-window",
  ProductBroomClean = "product-broom-clean",
  ProductBuggy = "product-buggy",
  ProductBuilding = "product-building",
  ProductBullhorn = "product-bullhorn",
  ProductCalculator = "product-calculator",
  ProductCalendar = "product-calendar",
  ProductCamera = "product-camera",
  ProductCandle = "product-candle",
  ProductCarAccident = "product-car-accident",
  ProductCarFront = "product-car-front",
  ProductCarMobility = "product-car-mobility",
  ProductCarSmall = "product-car-small",
  ProductCarTachoFast = "product-car-tacho-fast",
  ProductCarTrailer = "product-car-trailer",
  ProductCar = "product-car",
  ProductCaravan = "product-caravan",
  ProductCareInsurance = "product-care-insurance",
  ProductCertificate = "product-certificate",
  ProductCheckPaperF = "product-check-paper-f",
  ProductCheckPaper = "product-check-paper",
  ProductCheck = "product-check",
  ProductCity = "product-city",
  ProductCleanupTrash = "product-cleanup-trash",
  ProductClock = "product-clock",
  ProductCloud = "product-cloud",
  ProductCogWheel = "product-cog-wheel",
  ProductCogWheels = "product-cog-wheels",
  ProductCoinsMoneyF = "product-coins-money-f",
  ProductCoinsMoney = "product-coins-money",
  ProductCommunication = "product-communication",
  ProductComputer = "product-computer",
  ProductCouch = "product-couch",
  ProductCreditCard = "product-credit-card",
  ProductCrossTriangle = "product-cross-triangle",
  ProductCross = "product-cross",
  ProductDangerF = "product-danger-f",
  ProductDanger = "product-danger",
  ProductDataExchange = "product-data-exchange",
  ProductDiversity = "product-diversity",
  ProductDollar = "product-dollar",
  ProductDoor = "product-door",
  ProductElectricPlug = "product-electric-plug",
  ProductExcavator = "product-excavator",
  ProductExpensiveObjectsJewelery = "product-expensive-objects-jewelery",
  ProductEyeOverviewSight = "product-eye-overview-sight",
  ProductFamily = "product-family",
  ProductFire = "product-fire",
  ProductFolder = "product-folder",
  ProductForkLiftTruck = "product-fork-lift-truck",
  ProductFortune = "product-fortune",
  ProductGarage = "product-garage",
  ProductGuideNavigation = "product-guide-navigation",
  ProductHandClickInfo = "product-hand-click-info",
  ProductHandFingerPointing = "product-hand-finger-pointing",
  ProductHandGetMoney = "product-hand-get-money",
  ProductHandThumbsUp = "product-hand-thumbs-up",
  ProductHeadsetSupport = "product-headset-support",
  ProductHealthBagDoctor = "product-health-bag-doctor",
  ProductHealthStethoscope = "product-health-stethoscope",
  ProductHealth = "product-health",
  ProductHeartEmployeeEngagement = "product-heart-employee-engagement",
  ProductHeart = "product-heart",
  ProductHelmet = "product-helmet",
  ProductHelpInformation = "product-help-information",
  ProductHelpQuestion = "product-help-question",
  ProductHelp = "product-help",
  ProductHomeOffice = "product-home-office",
  ProductHourglass = "product-hourglass",
  ProductHouseBrokenWindow = "product-house-broken-window",
  ProductHouseFire = "product-house-fire",
  ProductHouseImportant = "product-house-important",
  ProductHouseMoney = "product-house-money",
  ProductHouseSafe = "product-house-safe",
  ProductHouseWaterDamage = "product-house-water-damage",
  ProductHouse = "product-house",
  ProductHydroPower = "product-hydro-power",
  ProductImportantInfo = "product-important-info",
  ProductIncomePrecaution = "product-income-precaution",
  ProductInfoSheet = "product-info-sheet",
  ProductInjuryPlaster = "product-injury-plaster",
  ProductJobProcesses = "product-job-processes",
  ProductKeys = "product-keys",
  ProductLaptop = "product-laptop",
  ProductLaw = "product-law",
  ProductLightBulbIdea = "product-light-bulb-idea",
  ProductLocatePositionF = "product-locate-position-f",
  ProductLocatePosition = "product-locate-position",
  ProductLock = "product-lock",
  ProductMail = "product-mail",
  ProductMedia = "product-media",
  ProductMobility = "product-mobility",
  ProductMoneyBanknote = "product-money-banknote",
  ProductMoneyExchange = "product-money-exchange",
  ProductMoneySuitcase = "product-money-suitcase",
  ProductMotorcycle = "product-motorcycle",
  ProductMouse = "product-mouse",
  ProductMusic = "product-music",
  ProductNatureLeaf = "product-nature-leaf",
  ProductNewspaper = "product-newspaper",
  ProductNotebook = "product-notebook",
  ProductOfficeChair = "product-office-chair",
  ProductPagesDocuments = "product-pages-documents",
  ProductPaperDocument = "product-paper-document",
  ProductPaperLock = "product-paper-lock",
  ProductPartnerHandshake = "product-partner-handshake",
  ProductPen = "product-pen",
  ProductPensionRockerChair = "product-pension-rocker-chair",
  ProductPeopleCollaboration = "product-people-collaboration",
  ProductPeopleCommunicationExternal = "product-people-communication-external",
  ProductPeopleCommunicationInternal = "product-people-communication-internal",
  ProductPeopleConnect = "product-people-connect",
  ProductPersonHeartPeopleLove = "product-person-heart-people-love",
  ProductPerson = "product-person",
  ProductPetHealthInsurance = "product-pet-health-insurance",
  ProductPetOwnerLiability = "product-pet-owner-liability",
  ProductPhoneCall = "product-phone-call",
  ProductPlane = "product-plane",
  ProductPlusMinus = "product-plus-minus",
  ProductPlus = "product-plus",
  ProductPodcast = "product-podcast",
  ProductPowerPylon = "product-power-pylon",
  ProductPrecaution = "product-precaution",
  ProductPresent = "product-present",
  ProductPrivatePension = "product-private-pension",
  ProductPuzzlePieces = "product-puzzle-pieces",
  ProductPuzzle = "product-puzzle",
  ProductRadio = "product-radio",
  ProductRepair = "product-repair",
  ProductRewards = "product-rewards",
  ProductRocket = "product-rocket",
  ProductSave = "product-save",
  ProductSearchDocument = "product-search-document",
  ProductSearch = "product-search",
  ProductShareChart = "product-share-chart",
  ProductShareGraphArrowDown = "product-share-graph-arrow-down",
  ProductShareGraphArrowUp = "product-share-graph-arrow-up",
  ProductSharingConnect = "product-sharing-connect",
  ProductShieldHand = "product-shield-hand",
  ProductShield = "product-shield",
  ProductShoppingCart = "product-shopping-cart",
  ProductSmartphone = "product-smartphone",
  ProductSoccer = "product-Soccer",
  ProductSocialMediaFacebookMessenger = "product-social-media-facebook-messenger",
  ProductSocialMediaFacebook = "product-social-media-facebook",
  ProductSocialMediaLinkedin = "product-social-media-linkedin",
  ProductSocialMediaTwitter = "product-social-media-twitter",
  ProductSocialMediaWhatsapp = "product-social-media-whatsapp",
  ProductSolarPowerModules = "product-solar-power-modules",
  ProductSportSailingShip = "product-sport-sailing-ship",
  ProductSportTrainer = "product-sport-trainer",
  ProductSportsCar = "product-sports-car",
  ProductSports = "product-sports",
  ProductStarEvent = "product-star-event",
  ProductStarsSkyGalaxy = "product-stars-sky-galaxy",
  ProductSteeringWheel = "product-steering-wheel",
  ProductStockDataGraph = "product-stock-data-graph",
  ProductStoveCooker = "product-stove-cooker",
  ProductStrategy = "product-strategy",
  ProductStudentSchoolGraduation = "product-student-school-graduation",
  ProductSurvey = "product-survey",
  ProductSuvCar = "product-SUV-car",
  ProductTabletIpadApps = "product-tablet-ipad-apps",
  ProductTarget = "product-target",
  ProductTelematicCarFront = "product-telematic-car-front",
  ProductTelematicCarSide = "product-telematic-car-side",
  ProductThermalPowerPlant = "product-thermal-power-plant",
  ProductThermometer = "product-thermometer",
  ProductThief = "product-thief",
  ProductThunderstorm = "product-thunderstorm",
  ProductTiresWheel = "product-tires-wheel",
  ProductToDoList = "product-to-do-list",
  ProductTooth = "product-tooth",
  ProductTravel = "product-travel",
  ProductTruck = "product-truck",
  ProductTv = "product-tv",
  ProductUmbrellaProtection = "product-umbrella-protection",
  ProductVideoCamera = "product-video-camera",
  ProductVoiceOfTheCustomer = "product-voice-of-the-customer",
  ProductWallBalance = "product-wall-balance",
  ProductWasher = "product-washer",
  ProductWaterTap = "product-water-tap",
  ProductWateringCan = "product-watering-can",
  ProductWheelchair = "product-wheelchair",
  ProductWindTurbineOffshore = "product-wind-turbine-offshore",
  ProductWindTurbineOnshore = "product-wind-turbine-onshore",
  ProductWorldGlobe = "product-world-globe",
  ProductWorldWideWe = "product-world-wide-we",
  Refresh = "refresh",
  SaveO = "save-o",
  Search = "search",
  SentimentDissatisfied = "sentiment-dissatisfied",
  SentimentNeutral = "sentiment-neutral",
  SentimentSatisfied = "sentiment-satisfied",
  SentimentVeryDissatisfied = "sentiment-very-dissatisfied",
  SentimentVerySatisfied = "sentiment-very-satisfied",
  SetTimer = "set-timer",
  SettingO = "setting-o",
  Setting = "setting",
  Share = "share",
  SidebarLeft = "sidebar-left",
  SidebarRight = "sidebar-right",
  Skyscraper = "skyscraper",
  SliderGraphO = "slider-graph-o",
  SpeakerOffO = "speaker-off-o",
  SpeakerOff = "speaker-off",
  SpeakerOnO = "speaker-on-o",
  SpeakerOn = "speaker-on",
  SpeechBubbleDotsO = "speech-bubble-dots-o",
  SpeechBubbleDots = "speech-bubble-dots",
  SpeechBubbleO = "speech-bubble-o",
  SpeechBubble = "speech-bubble",
  StarHalfFull = "star-half-full",
  StarO = "star-o",
  Star = "star",
  Telegram = "telegram",
  TiffText = "tiff-text",
  Tiff = "tiff",
  Tractor = "tractor",
  TrashO = "trash-o",
  Trash = "trash",
  Trees = "trees",
  TvWorldGlobe = "tv-world-globe",
  TwitterCircle = "twitter-circle",
  Twitter = "twitter",
  TxtText = "txt-text",
  Txt = "txt",
  UserBusinessO = "user-business-o",
  UserBusiness = "user-business",
  UserO = "user-o",
  User = "user",
  UsersO = "users-o",
  Users = "users",
  VidText = "vid-text",
  Vid = "vid",
  VoiceOfTheCustomerF = "voice-of-the-customer-f",
  WhatsappCircle = "whatsapp-circle",
  Whatsapp = "whatsapp",
  XingCircle = "xing-circle",
  Xing = "xing",
  XlsText = "xls-text",
  Xls = "xls",
  YoutubeCirclePlay = "youtube-circle-play",
  YoutubeCircle = "youtube-circle",
  Youtube = "youtube",
}

export const NDBX_ICONS_CODEPOINTS: { [key in NdbxIcons]: string } = {
  [NdbxIcons.ArrowDownSlim]: "61697",
  [NdbxIcons.ArrowDown]: "61698",
  [NdbxIcons.ArrowDownload]: "61699",
  [NdbxIcons.ArrowFirst]: "61700",
  [NdbxIcons.ArrowLast]: "61701",
  [NdbxIcons.ArrowLeftSlim]: "61702",
  [NdbxIcons.ArrowLeft]: "61703",
  [NdbxIcons.ArrowRightSlim]: "61704",
  [NdbxIcons.ArrowRight]: "61705",
  [NdbxIcons.ArrowUpSlim]: "61706",
  [NdbxIcons.ArrowUp]: "61707",
  [NdbxIcons.ArrowUpload]: "61708",
  [NdbxIcons.Back]: "61709",
  [NdbxIcons.Bars]: "61710",
  [NdbxIcons.BellO]: "61711",
  [NdbxIcons.BellOffO]: "61712",
  [NdbxIcons.BellOff]: "61713",
  [NdbxIcons.Bell]: "61714",
  [NdbxIcons.BoardShareGraph]: "61715",
  [NdbxIcons.BoltO]: "61716",
  [NdbxIcons.Bolt]: "61717",
  [NdbxIcons.BookmarkO]: "61718",
  [NdbxIcons.Bookmark]: "61719",
  [NdbxIcons.CalendarDateCheckO]: "61720",
  [NdbxIcons.CalendarDateCheck]: "61721",
  [NdbxIcons.CalendarDefault]: "61722",
  [NdbxIcons.CalendarReminderO]: "61723",
  [NdbxIcons.CalendarReminder]: "61724",
  [NdbxIcons.Calendar]: "61725",
  [NdbxIcons.CardO]: "61726",
  [NdbxIcons.CertificatePapers]: "61727",
  [NdbxIcons.ChatO]: "61728",
  [NdbxIcons.Chat]: "61729",
  [NdbxIcons.CheckCircle]: "61730",
  [NdbxIcons.Check]: "61731",
  [NdbxIcons.ChevronDownSmall]: "61732",
  [NdbxIcons.ChevronDown]: "61733",
  [NdbxIcons.ChevronLeftCircleO]: "61734",
  [NdbxIcons.ChevronLeftCircle]: "61735",
  [NdbxIcons.ChevronLeftSmall]: "61736",
  [NdbxIcons.ChevronLeft]: "61737",
  [NdbxIcons.ChevronRightCircleO]: "61738",
  [NdbxIcons.ChevronRightCircle]: "61739",
  [NdbxIcons.ChevronRightSmall]: "61740",
  [NdbxIcons.ChevronRight]: "61741",
  [NdbxIcons.ChevronUpSmall]: "61742",
  [NdbxIcons.ChevronUp]: "61743",
  [NdbxIcons.ClockO]: "61744",
  [NdbxIcons.Clock]: "61745",
  [NdbxIcons.CloseCircleO]: "61746",
  [NdbxIcons.CloseCircle]: "61747",
  [NdbxIcons.Close]: "61748",
  [NdbxIcons.CobrowsingO]: "61749",
  [NdbxIcons.CreditCardO]: "61750",
  [NdbxIcons.CreditCard]: "61751",
  [NdbxIcons.DocText]: "61752",
  [NdbxIcons.Doc]: "61753",
  [NdbxIcons.Dot]: "61754",
  [NdbxIcons.Download]: "61755",
  [NdbxIcons.Duplicate]: "61756",
  [NdbxIcons.EMailReadO]: "61757",
  [NdbxIcons.EMailRead]: "61758",
  [NdbxIcons.Edit]: "61759",
  [NdbxIcons.EllipsisH]: "61760",
  [NdbxIcons.EllipsisV]: "61761",
  [NdbxIcons.EpsText]: "61762",
  [NdbxIcons.Eps]: "61763",
  [NdbxIcons.ExclamationCircleO]: "61764",
  [NdbxIcons.ExclamationCircle]: "61765",
  [NdbxIcons.ExclamationTriangleO]: "61766",
  [NdbxIcons.ExclamationTriangle]: "61767",
  [NdbxIcons.ExportAndShare]: "61768",
  [NdbxIcons.FacebookCircle]: "61769",
  [NdbxIcons.Facebook]: "61770",
  [NdbxIcons.FileDocument]: "61771",
  [NdbxIcons.FileFlag]: "61772",
  [NdbxIcons.FileText]: "61773",
  [NdbxIcons.File]: "61774",
  [NdbxIcons.Filter]: "61775",
  [NdbxIcons.FountainPen]: "61776",
  [NdbxIcons.GoogleCircle]: "61777",
  [NdbxIcons.GooglePlus]: "61778",
  [NdbxIcons.Grapes]: "61779",
  [NdbxIcons.HandCogWheel]: "61780",
  [NdbxIcons.HandTray]: "61781",
  [NdbxIcons.HelmetConstruction]: "61782",
  [NdbxIcons.HelpQuestionF]: "61783",
  [NdbxIcons.ImgText]: "61784",
  [NdbxIcons.Img]: "61785",
  [NdbxIcons.InProgress]: "61786",
  [NdbxIcons.InfoCircleO]: "61787",
  [NdbxIcons.InfoCircle]: "61788",
  [NdbxIcons.InstagramCircle]: "61789",
  [NdbxIcons.Instagram]: "61790",
  [NdbxIcons.JpgText]: "61791",
  [NdbxIcons.Jpg]: "61792",
  [NdbxIcons.LaptopCogWheel]: "61793",
  [NdbxIcons.Launch]: "61794",
  [NdbxIcons.LinkedinCircle]: "61795",
  [NdbxIcons.Linkedin]: "61796",
  [NdbxIcons.List]: "61797",
  [NdbxIcons.LocationO]: "61798",
  [NdbxIcons.Location]: "61799",
  [NdbxIcons.LockO]: "61800",
  [NdbxIcons.LockUnlockO]: "61801",
  [NdbxIcons.LockUnlock]: "61802",
  [NdbxIcons.Lock]: "61803",
  [NdbxIcons.MailCircle]: "61804",
  [NdbxIcons.MailO]: "61805",
  [NdbxIcons.Mail]: "61806",
  [NdbxIcons.Manager]: "61807",
  [NdbxIcons.MessengerCircle]: "61808",
  [NdbxIcons.Messenger]: "61809",
  [NdbxIcons.MicrophoneDefault]: "61810",
  [NdbxIcons.MicrophoneMuteO]: "61811",
  [NdbxIcons.MicrophoneMute]: "61812",
  [NdbxIcons.Microphone]: "61813",
  [NdbxIcons.MinusCircleO]: "61814",
  [NdbxIcons.MinusCircle]: "61815",
  [NdbxIcons.Minus]: "61816",
  [NdbxIcons.Mp3Text]: "61817",
  [NdbxIcons.Mp3]: "61818",
  [NdbxIcons.Paperclip]: "61819",
  [NdbxIcons.PasswordHideO]: "61820",
  [NdbxIcons.PasswordHide]: "61821",
  [NdbxIcons.PasswordShowO]: "61822",
  [NdbxIcons.PasswordShow]: "61823",
  [NdbxIcons.Pause]: "61824",
  [NdbxIcons.PdfText]: "61825",
  [NdbxIcons.Pdf]: "61826",
  [NdbxIcons.Pen]: "61827",
  [NdbxIcons.PhoneChatO]: "61828",
  [NdbxIcons.PhoneChat]: "61829",
  [NdbxIcons.PhoneO]: "61830",
  [NdbxIcons.Phone]: "61831",
  [NdbxIcons.Play]: "61832",
  [NdbxIcons.PlusCircleO]: "61833",
  [NdbxIcons.PlusCircle]: "61834",
  [NdbxIcons.Plus]: "61835",
  [NdbxIcons.PodText]: "61836",
  [NdbxIcons.Pod]: "61837",
  [NdbxIcons.Popout]: "61838",
  [NdbxIcons.PptText]: "61839",
  [NdbxIcons.Ppt]: "61840",
  [NdbxIcons.PrintO]: "61841",
  [NdbxIcons.Print]: "61842",
  [NdbxIcons.ProductAZ]: "61843",
  [NdbxIcons.ProductAnimalCat]: "61844",
  [NdbxIcons.ProductAnimalDog]: "61845",
  [NdbxIcons.ProductAnimalHorse]: "61846",
  [NdbxIcons.ProductAnimalHuntingDeer]: "61847",
  [NdbxIcons.ProductAnimalPaw]: "61848",
  [NdbxIcons.ProductApartmentBuilding]: "61849",
  [NdbxIcons.ProductArrowDirectionPath]: "61850",
  [NdbxIcons.ProductAtSign]: "61851",
  [NdbxIcons.ProductBalanceScale]: "61852",
  [NdbxIcons.ProductBankMonumentInfo]: "61853",
  [NdbxIcons.ProductBattery]: "61854",
  [NdbxIcons.ProductBed]: "61855",
  [NdbxIcons.ProductBereavedDependentPension]: "61856",
  [NdbxIcons.ProductBike]: "61857",
  [NdbxIcons.ProductBlog]: "61858",
  [NdbxIcons.ProductBoardPaperNote]: "61859",
  [NdbxIcons.ProductBook]: "61860",
  [NdbxIcons.ProductBrain]: "61861",
  [NdbxIcons.ProductBrokenGlass]: "61862",
  [NdbxIcons.ProductBrokenWindow]: "61863",
  [NdbxIcons.ProductBroomClean]: "61864",
  [NdbxIcons.ProductBuggy]: "61865",
  [NdbxIcons.ProductBuilding]: "61866",
  [NdbxIcons.ProductBullhorn]: "61867",
  [NdbxIcons.ProductCalculator]: "61868",
  [NdbxIcons.ProductCalendar]: "61869",
  [NdbxIcons.ProductCamera]: "61870",
  [NdbxIcons.ProductCandle]: "61871",
  [NdbxIcons.ProductCarAccident]: "61872",
  [NdbxIcons.ProductCarFront]: "61873",
  [NdbxIcons.ProductCarMobility]: "61874",
  [NdbxIcons.ProductCarSmall]: "61875",
  [NdbxIcons.ProductCarTachoFast]: "61876",
  [NdbxIcons.ProductCarTrailer]: "61877",
  [NdbxIcons.ProductCar]: "61878",
  [NdbxIcons.ProductCaravan]: "61879",
  [NdbxIcons.ProductCareInsurance]: "61880",
  [NdbxIcons.ProductCertificate]: "61881",
  [NdbxIcons.ProductCheckPaperF]: "61882",
  [NdbxIcons.ProductCheckPaper]: "61883",
  [NdbxIcons.ProductCheck]: "61884",
  [NdbxIcons.ProductCity]: "61885",
  [NdbxIcons.ProductCleanupTrash]: "61886",
  [NdbxIcons.ProductClock]: "61887",
  [NdbxIcons.ProductCloud]: "61888",
  [NdbxIcons.ProductCogWheel]: "61889",
  [NdbxIcons.ProductCogWheels]: "61890",
  [NdbxIcons.ProductCoinsMoneyF]: "61891",
  [NdbxIcons.ProductCoinsMoney]: "61892",
  [NdbxIcons.ProductCommunication]: "61893",
  [NdbxIcons.ProductComputer]: "61894",
  [NdbxIcons.ProductCouch]: "61895",
  [NdbxIcons.ProductCreditCard]: "61896",
  [NdbxIcons.ProductCrossTriangle]: "61897",
  [NdbxIcons.ProductCross]: "61898",
  [NdbxIcons.ProductDangerF]: "61899",
  [NdbxIcons.ProductDanger]: "61900",
  [NdbxIcons.ProductDataExchange]: "61901",
  [NdbxIcons.ProductDiversity]: "61902",
  [NdbxIcons.ProductDollar]: "61903",
  [NdbxIcons.ProductDoor]: "61904",
  [NdbxIcons.ProductElectricPlug]: "61905",
  [NdbxIcons.ProductExcavator]: "61906",
  [NdbxIcons.ProductExpensiveObjectsJewelery]: "61907",
  [NdbxIcons.ProductEyeOverviewSight]: "61908",
  [NdbxIcons.ProductFamily]: "61909",
  [NdbxIcons.ProductFire]: "61910",
  [NdbxIcons.ProductFolder]: "61911",
  [NdbxIcons.ProductForkLiftTruck]: "61912",
  [NdbxIcons.ProductFortune]: "61913",
  [NdbxIcons.ProductGarage]: "61914",
  [NdbxIcons.ProductGuideNavigation]: "61915",
  [NdbxIcons.ProductHandClickInfo]: "61916",
  [NdbxIcons.ProductHandFingerPointing]: "61917",
  [NdbxIcons.ProductHandGetMoney]: "61918",
  [NdbxIcons.ProductHandThumbsUp]: "61919",
  [NdbxIcons.ProductHeadsetSupport]: "61920",
  [NdbxIcons.ProductHealthBagDoctor]: "61921",
  [NdbxIcons.ProductHealthStethoscope]: "61922",
  [NdbxIcons.ProductHealth]: "61923",
  [NdbxIcons.ProductHeartEmployeeEngagement]: "61924",
  [NdbxIcons.ProductHeart]: "61925",
  [NdbxIcons.ProductHelmet]: "61926",
  [NdbxIcons.ProductHelpInformation]: "61927",
  [NdbxIcons.ProductHelpQuestion]: "61928",
  [NdbxIcons.ProductHelp]: "61929",
  [NdbxIcons.ProductHomeOffice]: "61930",
  [NdbxIcons.ProductHourglass]: "61931",
  [NdbxIcons.ProductHouseBrokenWindow]: "61932",
  [NdbxIcons.ProductHouseFire]: "61933",
  [NdbxIcons.ProductHouseImportant]: "61934",
  [NdbxIcons.ProductHouseMoney]: "61935",
  [NdbxIcons.ProductHouseSafe]: "61936",
  [NdbxIcons.ProductHouseWaterDamage]: "61937",
  [NdbxIcons.ProductHouse]: "61938",
  [NdbxIcons.ProductHydroPower]: "61939",
  [NdbxIcons.ProductImportantInfo]: "61940",
  [NdbxIcons.ProductIncomePrecaution]: "61941",
  [NdbxIcons.ProductInfoSheet]: "61942",
  [NdbxIcons.ProductInjuryPlaster]: "61943",
  [NdbxIcons.ProductJobProcesses]: "61944",
  [NdbxIcons.ProductKeys]: "61945",
  [NdbxIcons.ProductLaptop]: "61946",
  [NdbxIcons.ProductLaw]: "61947",
  [NdbxIcons.ProductLightBulbIdea]: "61948",
  [NdbxIcons.ProductLocatePositionF]: "61949",
  [NdbxIcons.ProductLocatePosition]: "61950",
  [NdbxIcons.ProductLock]: "61951",
  [NdbxIcons.ProductMail]: "61952",
  [NdbxIcons.ProductMedia]: "61953",
  [NdbxIcons.ProductMobility]: "61954",
  [NdbxIcons.ProductMoneyBanknote]: "61955",
  [NdbxIcons.ProductMoneyExchange]: "61956",
  [NdbxIcons.ProductMoneySuitcase]: "61957",
  [NdbxIcons.ProductMotorcycle]: "61958",
  [NdbxIcons.ProductMouse]: "61959",
  [NdbxIcons.ProductMusic]: "61960",
  [NdbxIcons.ProductNatureLeaf]: "61961",
  [NdbxIcons.ProductNewspaper]: "61962",
  [NdbxIcons.ProductNotebook]: "61963",
  [NdbxIcons.ProductOfficeChair]: "61964",
  [NdbxIcons.ProductPagesDocuments]: "61965",
  [NdbxIcons.ProductPaperDocument]: "61966",
  [NdbxIcons.ProductPaperLock]: "61967",
  [NdbxIcons.ProductPartnerHandshake]: "61968",
  [NdbxIcons.ProductPen]: "61969",
  [NdbxIcons.ProductPensionRockerChair]: "61970",
  [NdbxIcons.ProductPeopleCollaboration]: "61971",
  [NdbxIcons.ProductPeopleCommunicationExternal]: "61972",
  [NdbxIcons.ProductPeopleCommunicationInternal]: "61973",
  [NdbxIcons.ProductPeopleConnect]: "61974",
  [NdbxIcons.ProductPersonHeartPeopleLove]: "61975",
  [NdbxIcons.ProductPerson]: "61976",
  [NdbxIcons.ProductPetHealthInsurance]: "61977",
  [NdbxIcons.ProductPetOwnerLiability]: "61978",
  [NdbxIcons.ProductPhoneCall]: "61979",
  [NdbxIcons.ProductPlane]: "61980",
  [NdbxIcons.ProductPlusMinus]: "61981",
  [NdbxIcons.ProductPlus]: "61982",
  [NdbxIcons.ProductPodcast]: "61983",
  [NdbxIcons.ProductPowerPylon]: "61984",
  [NdbxIcons.ProductPrecaution]: "61985",
  [NdbxIcons.ProductPresent]: "61986",
  [NdbxIcons.ProductPrivatePension]: "61987",
  [NdbxIcons.ProductPuzzlePieces]: "61988",
  [NdbxIcons.ProductPuzzle]: "61989",
  [NdbxIcons.ProductRadio]: "61990",
  [NdbxIcons.ProductRepair]: "61991",
  [NdbxIcons.ProductRewards]: "61992",
  [NdbxIcons.ProductRocket]: "61993",
  [NdbxIcons.ProductSave]: "61994",
  [NdbxIcons.ProductSearchDocument]: "61995",
  [NdbxIcons.ProductSearch]: "61996",
  [NdbxIcons.ProductShareChart]: "61997",
  [NdbxIcons.ProductShareGraphArrowDown]: "61998",
  [NdbxIcons.ProductShareGraphArrowUp]: "61999",
  [NdbxIcons.ProductSharingConnect]: "62000",
  [NdbxIcons.ProductShieldHand]: "62001",
  [NdbxIcons.ProductShield]: "62002",
  [NdbxIcons.ProductShoppingCart]: "62003",
  [NdbxIcons.ProductSmartphone]: "62004",
  [NdbxIcons.ProductSoccer]: "62005",
  [NdbxIcons.ProductSocialMediaFacebookMessenger]: "62006",
  [NdbxIcons.ProductSocialMediaFacebook]: "62007",
  [NdbxIcons.ProductSocialMediaLinkedin]: "62008",
  [NdbxIcons.ProductSocialMediaTwitter]: "62009",
  [NdbxIcons.ProductSocialMediaWhatsapp]: "62010",
  [NdbxIcons.ProductSolarPowerModules]: "62011",
  [NdbxIcons.ProductSportSailingShip]: "62012",
  [NdbxIcons.ProductSportTrainer]: "62013",
  [NdbxIcons.ProductSportsCar]: "62014",
  [NdbxIcons.ProductSports]: "62015",
  [NdbxIcons.ProductStarEvent]: "62016",
  [NdbxIcons.ProductStarsSkyGalaxy]: "62017",
  [NdbxIcons.ProductSteeringWheel]: "62018",
  [NdbxIcons.ProductStockDataGraph]: "62019",
  [NdbxIcons.ProductStoveCooker]: "62020",
  [NdbxIcons.ProductStrategy]: "62021",
  [NdbxIcons.ProductStudentSchoolGraduation]: "62022",
  [NdbxIcons.ProductSurvey]: "62023",
  [NdbxIcons.ProductSuvCar]: "62024",
  [NdbxIcons.ProductTabletIpadApps]: "62025",
  [NdbxIcons.ProductTarget]: "62026",
  [NdbxIcons.ProductTelematicCarFront]: "62027",
  [NdbxIcons.ProductTelematicCarSide]: "62028",
  [NdbxIcons.ProductThermalPowerPlant]: "62029",
  [NdbxIcons.ProductThermometer]: "62030",
  [NdbxIcons.ProductThief]: "62031",
  [NdbxIcons.ProductThunderstorm]: "62032",
  [NdbxIcons.ProductTiresWheel]: "62033",
  [NdbxIcons.ProductToDoList]: "62034",
  [NdbxIcons.ProductTooth]: "62035",
  [NdbxIcons.ProductTravel]: "62036",
  [NdbxIcons.ProductTruck]: "62037",
  [NdbxIcons.ProductTv]: "62038",
  [NdbxIcons.ProductUmbrellaProtection]: "62039",
  [NdbxIcons.ProductVideoCamera]: "62040",
  [NdbxIcons.ProductVoiceOfTheCustomer]: "62041",
  [NdbxIcons.ProductWallBalance]: "62042",
  [NdbxIcons.ProductWasher]: "62043",
  [NdbxIcons.ProductWaterTap]: "62044",
  [NdbxIcons.ProductWateringCan]: "62045",
  [NdbxIcons.ProductWheelchair]: "62046",
  [NdbxIcons.ProductWindTurbineOffshore]: "62047",
  [NdbxIcons.ProductWindTurbineOnshore]: "62048",
  [NdbxIcons.ProductWorldGlobe]: "62049",
  [NdbxIcons.ProductWorldWideWe]: "62050",
  [NdbxIcons.Refresh]: "62051",
  [NdbxIcons.SaveO]: "62052",
  [NdbxIcons.Search]: "62053",
  [NdbxIcons.SentimentDissatisfied]: "62054",
  [NdbxIcons.SentimentNeutral]: "62055",
  [NdbxIcons.SentimentSatisfied]: "62056",
  [NdbxIcons.SentimentVeryDissatisfied]: "62057",
  [NdbxIcons.SentimentVerySatisfied]: "62058",
  [NdbxIcons.SetTimer]: "62059",
  [NdbxIcons.SettingO]: "62060",
  [NdbxIcons.Setting]: "62061",
  [NdbxIcons.Share]: "62062",
  [NdbxIcons.SidebarLeft]: "62063",
  [NdbxIcons.SidebarRight]: "62064",
  [NdbxIcons.Skyscraper]: "62065",
  [NdbxIcons.SliderGraphO]: "62066",
  [NdbxIcons.SpeakerOffO]: "62067",
  [NdbxIcons.SpeakerOff]: "62068",
  [NdbxIcons.SpeakerOnO]: "62069",
  [NdbxIcons.SpeakerOn]: "62070",
  [NdbxIcons.SpeechBubbleDotsO]: "62071",
  [NdbxIcons.SpeechBubbleDots]: "62072",
  [NdbxIcons.SpeechBubbleO]: "62073",
  [NdbxIcons.SpeechBubble]: "62074",
  [NdbxIcons.StarHalfFull]: "62075",
  [NdbxIcons.StarO]: "62076",
  [NdbxIcons.Star]: "62077",
  [NdbxIcons.Telegram]: "62078",
  [NdbxIcons.TiffText]: "62079",
  [NdbxIcons.Tiff]: "62080",
  [NdbxIcons.Tractor]: "62081",
  [NdbxIcons.TrashO]: "62082",
  [NdbxIcons.Trash]: "62083",
  [NdbxIcons.Trees]: "62084",
  [NdbxIcons.TvWorldGlobe]: "62085",
  [NdbxIcons.TwitterCircle]: "62086",
  [NdbxIcons.Twitter]: "62087",
  [NdbxIcons.TxtText]: "62088",
  [NdbxIcons.Txt]: "62089",
  [NdbxIcons.UserBusinessO]: "62090",
  [NdbxIcons.UserBusiness]: "62091",
  [NdbxIcons.UserO]: "62092",
  [NdbxIcons.User]: "62093",
  [NdbxIcons.UsersO]: "62094",
  [NdbxIcons.Users]: "62095",
  [NdbxIcons.VidText]: "62096",
  [NdbxIcons.Vid]: "62097",
  [NdbxIcons.VoiceOfTheCustomerF]: "62098",
  [NdbxIcons.WhatsappCircle]: "62099",
  [NdbxIcons.Whatsapp]: "62100",
  [NdbxIcons.XingCircle]: "62101",
  [NdbxIcons.Xing]: "62102",
  [NdbxIcons.XlsText]: "62103",
  [NdbxIcons.Xls]: "62104",
  [NdbxIcons.YoutubeCirclePlay]: "62105",
  [NdbxIcons.YoutubeCircle]: "62106",
  [NdbxIcons.Youtube]: "62107",
};

export type NdbxIconsId =
  | "arrow-down-slim"
  | "arrow-down"
  | "arrow-download"
  | "arrow-first"
  | "arrow-last"
  | "arrow-left-slim"
  | "arrow-left"
  | "arrow-right-slim"
  | "arrow-right"
  | "arrow-up-slim"
  | "arrow-up"
  | "arrow-upload"
  | "back"
  | "bars"
  | "bell-o"
  | "bell-off-o"
  | "bell-off"
  | "bell"
  | "board-share-graph"
  | "bolt-o"
  | "bolt"
  | "bookmark-o"
  | "bookmark"
  | "calendar-date-check-o"
  | "calendar-date-check"
  | "calendar-default"
  | "calendar-reminder-o"
  | "calendar-reminder"
  | "calendar"
  | "card-o"
  | "certificate-papers"
  | "chat-o"
  | "chat"
  | "check-circle"
  | "check"
  | "chevron-down-small"
  | "chevron-down"
  | "chevron-left-circle-o"
  | "chevron-left-circle"
  | "chevron-left-small"
  | "chevron-left"
  | "chevron-right-circle-o"
  | "chevron-right-circle"
  | "chevron-right-small"
  | "chevron-right"
  | "chevron-up-small"
  | "chevron-up"
  | "clock-o"
  | "clock"
  | "close-circle-o"
  | "close-circle"
  | "close"
  | "cobrowsing-o"
  | "credit-card-o"
  | "credit-card"
  | "doc-text"
  | "doc"
  | "dot"
  | "download"
  | "duplicate"
  | "e-mail-read-o"
  | "e-mail-read"
  | "edit"
  | "ellipsis-h"
  | "ellipsis-v"
  | "eps-text"
  | "eps"
  | "exclamation-circle-o"
  | "exclamation-circle"
  | "exclamation-triangle-o"
  | "exclamation-triangle"
  | "export-and-share"
  | "facebook-circle"
  | "facebook"
  | "file-document"
  | "file-flag"
  | "file-text"
  | "file"
  | "filter"
  | "fountain-pen"
  | "google-circle"
  | "google-plus"
  | "grapes"
  | "hand-cog-wheel"
  | "hand-tray"
  | "helmet-construction"
  | "help-question-f"
  | "img-text"
  | "img"
  | "in-progress"
  | "info-circle-o"
  | "info-circle"
  | "instagram-circle"
  | "instagram"
  | "jpg-text"
  | "jpg"
  | "laptop-cog-wheel"
  | "launch"
  | "linkedin-circle"
  | "linkedin"
  | "list"
  | "location-o"
  | "location"
  | "lock-o"
  | "lock-unlock-o"
  | "lock-unlock"
  | "lock"
  | "mail-circle"
  | "mail-o"
  | "mail"
  | "manager"
  | "messenger-circle"
  | "messenger"
  | "microphone-default"
  | "microphone-mute-o"
  | "microphone-mute"
  | "microphone"
  | "minus-circle-o"
  | "minus-circle"
  | "minus"
  | "mp3-text"
  | "mp3"
  | "paperclip"
  | "password-hide-o"
  | "password-hide"
  | "password-show-o"
  | "password-show"
  | "pause"
  | "pdf-text"
  | "pdf"
  | "pen"
  | "phone-chat-o"
  | "phone-chat"
  | "phone-o"
  | "phone"
  | "play"
  | "plus-circle-o"
  | "plus-circle"
  | "plus"
  | "pod-text"
  | "pod"
  | "popout"
  | "ppt-text"
  | "ppt"
  | "print-o"
  | "print"
  | "product-a-z"
  | "product-animal-cat"
  | "product-animal-dog"
  | "product-animal-horse"
  | "product-animal-hunting-deer"
  | "product-animal-paw"
  | "product-apartment-building"
  | "product-arrow-direction-path"
  | "product-at-sign"
  | "product-balance-scale"
  | "product-bank-monument-info"
  | "product-battery"
  | "product-bed"
  | "product-bereaved-dependent-pension"
  | "product-bike"
  | "product-blog"
  | "product-board-paper-note"
  | "product-book"
  | "product-brain"
  | "product-broken-glass"
  | "product-broken-window"
  | "product-broom-clean"
  | "product-buggy"
  | "product-building"
  | "product-bullhorn"
  | "product-calculator"
  | "product-calendar"
  | "product-camera"
  | "product-candle"
  | "product-car-accident"
  | "product-car-front"
  | "product-car-mobility"
  | "product-car-small"
  | "product-car-tacho-fast"
  | "product-car-trailer"
  | "product-car"
  | "product-caravan"
  | "product-care-insurance"
  | "product-certificate"
  | "product-check-paper-f"
  | "product-check-paper"
  | "product-check"
  | "product-city"
  | "product-cleanup-trash"
  | "product-clock"
  | "product-cloud"
  | "product-cog-wheel"
  | "product-cog-wheels"
  | "product-coins-money-f"
  | "product-coins-money"
  | "product-communication"
  | "product-computer"
  | "product-couch"
  | "product-credit-card"
  | "product-cross-triangle"
  | "product-cross"
  | "product-danger-f"
  | "product-danger"
  | "product-data-exchange"
  | "product-diversity"
  | "product-dollar"
  | "product-door"
  | "product-electric-plug"
  | "product-excavator"
  | "product-expensive-objects-jewelery"
  | "product-eye-overview-sight"
  | "product-family"
  | "product-fire"
  | "product-folder"
  | "product-fork-lift-truck"
  | "product-fortune"
  | "product-garage"
  | "product-guide-navigation"
  | "product-hand-click-info"
  | "product-hand-finger-pointing"
  | "product-hand-get-money"
  | "product-hand-thumbs-up"
  | "product-headset-support"
  | "product-health-bag-doctor"
  | "product-health-stethoscope"
  | "product-health"
  | "product-heart-employee-engagement"
  | "product-heart"
  | "product-helmet"
  | "product-help-information"
  | "product-help-question"
  | "product-help"
  | "product-home-office"
  | "product-hourglass"
  | "product-house-broken-window"
  | "product-house-fire"
  | "product-house-important"
  | "product-house-money"
  | "product-house-safe"
  | "product-house-water-damage"
  | "product-house"
  | "product-hydro-power"
  | "product-important-info"
  | "product-income-precaution"
  | "product-info-sheet"
  | "product-injury-plaster"
  | "product-job-processes"
  | "product-keys"
  | "product-laptop"
  | "product-law"
  | "product-light-bulb-idea"
  | "product-locate-position-f"
  | "product-locate-position"
  | "product-lock"
  | "product-mail"
  | "product-media"
  | "product-mobility"
  | "product-money-banknote"
  | "product-money-exchange"
  | "product-money-suitcase"
  | "product-motorcycle"
  | "product-mouse"
  | "product-music"
  | "product-nature-leaf"
  | "product-newspaper"
  | "product-notebook"
  | "product-office-chair"
  | "product-pages-documents"
  | "product-paper-document"
  | "product-paper-lock"
  | "product-partner-handshake"
  | "product-pen"
  | "product-pension-rocker-chair"
  | "product-people-collaboration"
  | "product-people-communication-external"
  | "product-people-communication-internal"
  | "product-people-connect"
  | "product-person-heart-people-love"
  | "product-person"
  | "product-pet-health-insurance"
  | "product-pet-owner-liability"
  | "product-phone-call"
  | "product-plane"
  | "product-plus-minus"
  | "product-plus"
  | "product-podcast"
  | "product-power-pylon"
  | "product-precaution"
  | "product-present"
  | "product-private-pension"
  | "product-puzzle-pieces"
  | "product-puzzle"
  | "product-radio"
  | "product-repair"
  | "product-rewards"
  | "product-rocket"
  | "product-save"
  | "product-search-document"
  | "product-search"
  | "product-share-chart"
  | "product-share-graph-arrow-down"
  | "product-share-graph-arrow-up"
  | "product-sharing-connect"
  | "product-shield-hand"
  | "product-shield"
  | "product-shopping-cart"
  | "product-smartphone"
  | "product-Soccer"
  | "product-social-media-facebook-messenger"
  | "product-social-media-facebook"
  | "product-social-media-linkedin"
  | "product-social-media-twitter"
  | "product-social-media-whatsapp"
  | "product-solar-power-modules"
  | "product-sport-sailing-ship"
  | "product-sport-trainer"
  | "product-sports-car"
  | "product-sports"
  | "product-star-event"
  | "product-stars-sky-galaxy"
  | "product-steering-wheel"
  | "product-stock-data-graph"
  | "product-stove-cooker"
  | "product-strategy"
  | "product-student-school-graduation"
  | "product-survey"
  | "product-SUV-car"
  | "product-tablet-ipad-apps"
  | "product-target"
  | "product-telematic-car-front"
  | "product-telematic-car-side"
  | "product-thermal-power-plant"
  | "product-thermometer"
  | "product-thief"
  | "product-thunderstorm"
  | "product-tires-wheel"
  | "product-to-do-list"
  | "product-tooth"
  | "product-travel"
  | "product-truck"
  | "product-tv"
  | "product-umbrella-protection"
  | "product-video-camera"
  | "product-voice-of-the-customer"
  | "product-wall-balance"
  | "product-washer"
  | "product-water-tap"
  | "product-watering-can"
  | "product-wheelchair"
  | "product-wind-turbine-offshore"
  | "product-wind-turbine-onshore"
  | "product-world-globe"
  | "product-world-wide-we"
  | "refresh"
  | "save-o"
  | "search"
  | "sentiment-dissatisfied"
  | "sentiment-neutral"
  | "sentiment-satisfied"
  | "sentiment-very-dissatisfied"
  | "sentiment-very-satisfied"
  | "set-timer"
  | "setting-o"
  | "setting"
  | "share"
  | "sidebar-left"
  | "sidebar-right"
  | "skyscraper"
  | "slider-graph-o"
  | "speaker-off-o"
  | "speaker-off"
  | "speaker-on-o"
  | "speaker-on"
  | "speech-bubble-dots-o"
  | "speech-bubble-dots"
  | "speech-bubble-o"
  | "speech-bubble"
  | "star-half-full"
  | "star-o"
  | "star"
  | "telegram"
  | "tiff-text"
  | "tiff"
  | "tractor"
  | "trash-o"
  | "trash"
  | "trees"
  | "tv-world-globe"
  | "twitter-circle"
  | "twitter"
  | "txt-text"
  | "txt"
  | "user-business-o"
  | "user-business"
  | "user-o"
  | "user"
  | "users-o"
  | "users"
  | "vid-text"
  | "vid"
  | "voice-of-the-customer-f"
  | "whatsapp-circle"
  | "whatsapp"
  | "xing-circle"
  | "xing"
  | "xls-text"
  | "xls"
  | "youtube-circle-play"
  | "youtube-circle"
  | "youtube";
